export default "__VITE_ASSET__D1c_zdma__"